import React from 'react';
import PropTypes from 'prop-types';

const Locker = ({ outlineColor, s: { width, height } }) => (
  <svg width={width} height={height} viewBox="0 0 64 64" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.491 7.596H32.754V30.86h17.79V9.65c0-1.135-.92-2.054-2.053-2.054Zm3.65 23.264V54.35A3.65 3.65 0 0 1 48.49 58H15.65A3.65 3.65 0 0 1 12 54.35V9.65A3.65 3.65 0 0 1 15.65 6H48.49a3.65 3.65 0 0 1 3.65 3.65v21.21Zm-1.597 1.596h-17.79v23.947h15.737a2.053 2.053 0 0 0 2.053-2.052V32.456ZM15.649 7.596h15.509v48.808H15.649a2.053 2.053 0 0 1-2.052-2.053V9.649c0-1.134.918-2.053 2.052-2.053Zm20.755 11.062a.798.798 0 0 0-1.597 0v4.625a.798.798 0 0 0 1.596 0v-4.625Zm-16.308 30.22a.798.798 0 0 0 0 1.596h4.574a.798.798 0 0 0 0-1.597h-4.574Zm-.798 4.447c0-.441.358-.799.799-.799h4.573a.798.798 0 0 1 0 1.597h-4.574a.798.798 0 0 1-.798-.798Zm9.807-23.72a.798.798 0 0 0-1.596 0v4.625a.798.798 0 0 0 1.596 0v-4.625Zm6.5 12.886c.441 0 .799.358.799.798v4.625a.798.798 0 0 1-1.597 0V43.29c0-.44.357-.798.798-.798Z"
      fill={outlineColor}
    />
  </svg>
);

Locker.defaultProps = {
  outlineColor: '#000000',
  s: {},
};

Locker.propTypes = {
  s: PropTypes.object,
  outlineColor: PropTypes.string,
};

export default Locker;
